import Link from "next/link"
import { ArrowRight, Wrench } from "lucide-react"
import { getRelatedTools } from "@/components/blog/blog-post-footer-sections"
import { ToolIllustration } from "@/components/tools/tool-illustration"

interface SidebarToolLinksProps {
  category?: string
  /** Explicit list, for surfaces whose relevant tools vary per page rather than
   *  per category (pest profiles: the grub calculator only fits soil grubs). */
  tools?: { href: string; label: string }[]
}

export function SidebarToolLinks({ category, tools: toolsOverride }: SidebarToolLinksProps) {
  const tools = toolsOverride ?? getRelatedTools(category ?? "")

  if (tools.length === 0) return null

  return (
    <div className="ds-glass rounded-[18px] p-4 transition-[transform,box-shadow] duration-300 hover:-translate-y-1" style={{ boxShadow: "0 4px 16px -8px rgba(18,46,30,0.22), 0 1px 3px -1px rgba(18,46,30,0.12)" }}>
      <div className="flex items-center gap-2 mb-3">
        <span className="grid place-items-center rounded-lg border border-white/70 bg-green-50/85 text-green-700 w-6 h-6">
          <Wrench className="w-3.5 h-3.5" />
        </span>
        <h3 className="text-xs font-bold text-green-700 uppercase tracking-wide">
          Free Tools
        </h3>
      </div>
      <div className="-mx-2">
        {tools.map((tool, i) => (
          <Link
            key={tool.href}
            href={tool.href}
            prefetch={false}
            className={`group flex items-center gap-3 px-2 py-2.5 rounded-xl transition-all hover:translate-x-1 hover:bg-white/55 hover:backdrop-blur-md ${
              i > 0 ? "border-t border-white/55" : ""
            }`}
          >
            <span className="grid place-items-center rounded-xl border border-green-100 bg-green-50/85 w-9 h-9 flex-shrink-0 transition-transform duration-200 group-hover:scale-105 [&_svg]:h-8 [&_svg]:w-8">
              <ToolIllustration href={tool.href} />
            </span>
            <span className="text-sm font-medium text-gray-800 group-hover:text-green-700 flex-1 leading-snug">
              {tool.label}
            </span>
            <ArrowRight className="w-3.5 h-3.5 text-gray-400 group-hover:text-green-700 group-hover:translate-x-0.5 transition-all" />
          </Link>
        ))}
      </div>
    </div>
  )
}
